import mixpanel from 'mixpanel-browser';

const MIXPANEL_TOKEN = process.env.NEXT_PUBLIC_MIXPANEL_TOKEN;

export const initMixpanel = () => {
  if (!MIXPANEL_TOKEN) {
    // eslint-disable-next-line no-console
    console.warn(
      'Mixpanel token is missing or not in production ! Mixpanel will not be initialized.'
    );
    return;
  }

  mixpanel.init(MIXPANEL_TOKEN, {
    autocapture: false,
    track_pageview: true,
    record_sessions_percent: 100,
    record_idle_timeout_ms: 5 * 60 * 1000,
    record_mask_text_selector: '',
    record_block_selector: '',
  });
};
